// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*:focus 
{
    outline: none;
}

:root
{
    --navbar-color : white;
    --navbar-change-color : #001E60;
}

input:-webkit-autofill, input:-webkit-autofill:focus 
{
    transition: background-color 600000s 0s, color 600000s 0s;
}

input[data-autocompleted] 
{
    background-color: transparent !important;
}

.service-container
{
    color: white;
    font-weight: 300;
    transition: 300ms ease;
    position: relative;
    padding-top: 30px;
    margin-left: auto;
    margin-right: auto;
    max-width: 1600px;
    overflow-x: hidden;
}

.service-title
{
    color: white;
    font-size: clamp(18px, 5vw, 32px);
    font-weight: 300;
    text-decoration: none;
    text-align: center;
    background-color: #001E60;
    margin-left: 5%;
    margin-right: 5%;
    margin-top : 1%;
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 40px;
}

.service-navbar
{
    display: flex;
    justify-content: space-evenly;
    flex-flow: wrap;
    margin-bottom : 40px;
    margin-right: 5%;
    margin-left: 5%;
    padding-top: 10px;
}

.service-navbar-text
{
    padding-bottom : 4px;
    transition: 300ms ease;
    position: relative;
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 30px;
}

.service-navbar-link
{
    padding-bottom : 4px;
    transition: 300ms ease;
    position: relative;
    border-bottom: 3px solid var(--navbar-color);
}

.service-navbar-text a
{
    text-decoration: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    font-weight: 400;
    transition: 300ms ease;
}

.service-navbar-text a:hover
{
    color:#001E60;
}

.service-navbar-plus-container
{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 25px;
}

#overview-meeting-details
{
    width: 45%;
}

.service-image-container
{
    width : 40%;
    max-height: 350px;
    border-radius : 20px;
}

#service-navbar-plus
{
    background-color:#001E60;
    color: #ecaa1e;
    cursor: pointer;
    transition: 300ms ease;
    border-radius: 10000px;
    position: relative;
}

#remove-service-navbar-text
{
    position: absolute;
    margin-left : 8px;
    text-decoration: none;
    color:#001E60;
    background-color: #ecaa1e;
    border-radius: 10000px;
    cursor: pointer;
    transition: 300ms ease;
    scale: 1.3;
    top: -5px;
}

#remove-service-navbar-text:hover
{
    background-color:#001E60;
    color: #ecaa1e;
}

#select-navbar-section
{
    appearance: none;
}
.sign-up-form-box-input
{
    width: 100%;
    background-color: #001E60;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    transition: 300ms ease;
}
.sign-up-form
{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
}

.hidden
{
    display: none;
}

.file-container p
{
    text-align: center;
}

.sign-up-form-container
{
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
    align-items: center;
}

#sign-up-header
{
    font-size : 25px;
    font-weight : 400;
    margin-bottom : 40px;
    text-align: center;
}

.sign-up-form-text
{
    display: block;
    margin-bottom: 10px;
    color: white;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
}

.sign-up-form-input
{
    padding: 8px 10px;
    margin-bottom: 60px;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 15px;
    width: 100%;
    color: #001E60;
    font-weight: 400;
}

.sign-up-submit-container
{
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin: 50px 0%;
}

.sign-up-submit-button 
{
    width: 70%;
    background-color: #001E60;
    color: white;
    padding: 14px 20px;
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 2px;
    transition: 300ms ease;
}

.sign-up-submit-button:hover 
{
    background-color: #ecaa1e;
    color: #001E60;
}

.service-submit-button
{
    width: 100%;
    background-color: #001E60;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    transition: 300ms ease;
}

.service-submit-button:hover
{
    background-color: #ecaa1e;
    color: #001E60;
}

#name-container
{
    width : 45%;
}

#email-container
{
    width : 45%;
}

.faq
{
    display: flex;
    justify-content: center;
}

.service-info-container
{
    display: flex;
    justify-content: space-evenly;
    flex-flow: wrap;
    align-items: flex-start;
    padding-right: 4%;
    padding-left: 4%;
}

.service-info2-container
{
    display: flex;
    justify-content: space-around;
    flex-flow: wrap;
    align-items: flex-start;
    padding-right: 5%;
    padding-left: 5%;
    margin-bottom : 8%;
    padding-bottom: 5%;
}

#contact-container
{
    margin-bottom : 8%;
}

.service-author
{
    font-size : clamp(15px, 4vw, 25px);
    display: flex;
    justify-content: center;
    padding-bottom : 15px;
    text-align: center;
}

.service-header
{
    font-size : 22px;
    display: flex;
    justify-content: center;
    padding-bottom: 5px;
}

.service-details
{
    color: white;
    background-color: #00468D;
    font-size: clamp(8px, 3vh, 20px);
    font-weight: 400;
    line-height: 50px;
    position: relative;
    width: 75%;
    padding: 25px 25px;
    border-radius: 20px;
    background-size: cover;
    transition: 300ms ease;
}

.service-details u
{
    text-decoration: none;
    color: #ecaa1e;
}

.service-category-title
{
    text-align: center;
    margin-bottom : 20px;
    padding : 10px;
    font-size: 26px;
}

.service-category-container
{
    color: white;
    background-color: #00468D;
    font-size: clamp(10px, 4vh, 20px);
    font-weight: 400;
    line-height: 50px;
    padding: 25px 45px;
    border-radius: 20px;
    margin : 0px 8%;
    margin-bottom: 200px;
}

.service-categories
{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    cursor: pointer;
    padding-bottom : 50px;
}

.service-category
{
    width : 45%;
    border-radius: 15px;
    margin-right: 20px;
    transition: 300ms ease;
    padding-left: 15px;
}

.service-category:hover
{
    background-color: #001E60;
}

.service-description
{
    color: white;
    background-color: #00468D;
    font-size: clamp(10px, 4vh, 20px);
    font-weight: 400;
    line-height: 50px;
    padding: 25px 45px;
    border-radius: 20px;
    margin : 50px 8%;
    margin-bottom: 60px;
}

.meeting-description-text-box
{
    width : 100%;
    padding: 8px 10px;
    font-size: clamp(10px, 4vh, 20px);
    margin-bottom: 20px;
    margin-top : 10px;
    background : none;
    border : none;
    outline : none;
    color : white;
}

.authorization-container
{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0px 10%;
    margin-bottom: 50px;
    background-color:#0096C9;
    padding: 20px;
    border-radius: 10px;
    animation: fades-in 0.2s ease-in-out;
}

.authorization-container-title
{
    font-size: 26px;
    font-weight: 500;
    margin-top : 20px;
}

.sign-up-title
{
    color: white;
    font-size: clamp(20px, 2.3vw, 32px);
    font-weight: 300;
    text-decoration: none;
    text-align: center;
    background-color: #001E60;
    margin-top : 2%;
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 40px;
}

.sign-up-form-boxes
{
    width : 50%;
}

.club-title-text-box
{
    padding: 4px 10px;
    font-size: clamp(22px, 3vw, 32px);
    text-align: center;
    width : 80%;
    background : none;
    border : none;
    outline : none;
    color : white;
}

.meeting-details-title-box
{
    font-size: clamp(15px, 2.3vw, 25px);
    width : 80%;
    text-align: center;
    background : none;
    border : none;
    outline : none;
    color : white;
}

.meeting-details-text-box
{
    padding: 4px 5px;
    font-size: clamp(8px, 3vh, 20px);
    width : 80%;
    background : none;
    border : none;
    outline : none;
    color : white;
}

.contacts-container
{
    margin-bottom: 10px;
}

#requirements-container
{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.contacts-text-box
{
    padding: 4px 10px;
    font-size: clamp(8px, 3vh, 20px);
    width : 60%;
    background : none;
    border : none;
    outline : none;
    color : white;
}


.contacts-email-box
{
    padding: 4px 10px;
    font-size: clamp(8px, 3vh, 20px);
    width : 82%;
    background : none;
    border : none;
    outline : none;
    color : white;
}

.club-contacts-selection
{
    margin-top : 20px;
    background : none;
    border : none;
    outline : none;
    color : #ecaa1e;
    font-size: clamp(8px, 3vh, 20px);
}

.category-selection
{
    margin-top : 20px;
    background : none;
    border : none;
    outline : none;
    color : #ecaa1e;
    font-size: clamp(8px, 3vh, 20px);
    margin-right: 5px;
    
}

.category-select-button {
    background-color: #001E60;
    border-radius: 10px;
    padding: none;
    width: 25%;
    position: relative;
    top: 10px;
  }

.service-contact-name
{
    margin-right: 10px;
}

.service-contact-link
{
    text-decoration: underline;
    text-underline-offset: 5px;
}

#question-text-box
{
    width : 98%;
    word-wrap: break-word;
}

#answer-text-box
{
    width: 92%;
    font-size: clamp(8px, 3vh, 18px);
    margin-bottom : 20px;
}

#faq-container
{
    color: white;
    background-color: #00468D;
    font-size: clamp(8px, 3vh, 20px);
    font-weight: 400;
    line-height: 50px;
    position: relative;
    padding: 25px 25px;
    border-radius: 20px;
    background-size: cover;
    transition: 300ms ease;
    width: 80%;
    margin-bottom: 100px;
}

#faq-title 
{
    margin-bottom : 10px;
}

.application-buttons
{
    width: 90%;
    background-color: #001E60;
    color: white;
    padding: 14px 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 2px;
    transition: 300ms ease;
    text-align: center;
}

.sign-up-return-button
{
    width: 90%;
    background-color:#00468D;
    color: white;
    padding: 14px 20px;
    margin-top: 80px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 2px;
    transition: 300ms ease;
    text-align: center;
}

.sign-up-return-button:hover
{
    background-color: #001E60;
}

.authorization-text
{
    width : 90%;
    margin-top : 40px;
}

#draft-button
{
    margin-bottom : 0px;
}

#draft-button:hover
{
    background-color: #00468D;
}


#submit-button:hover 
{
    background-color: #ecaa1e;
    color : #00468D;
}

#save-button:hover 
{
    background-color: #00468D;
    color : #ecaa1e;
}

#file-container-with-file
{
    width: 40%;
    background-color: #001E60;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 7px 7px 12px rgba(0,0,0,0.05);
}

.file-container
{
    width: 40%;
    background: #00468D;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 7px 7px 12px rgba(0,0,0,0.05);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    cursor: pointer;
    height: 322px;
    transition: 300ms ease;
}



.file-container header
{
    color: white;
    font-size: clamp(20px, 2.3vw, 25px);
    font-weight: 500;
    text-align: center;
}

.file-container:hover {
    background-color: var(--dark-secondary-color);
}

.file-form
{
    height: 150px;
    display: flex;
    cursor: pointer;
    margin: 30px 0px 20px 0px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 5px;
    border: 2px dashed white;
    width: 80%;
}

#file-icon
{
    font-size: 50px;
    color: white;
    width : 100%;
    display: flex;
    justify-content: center;
}


.file-form p
{
    margin-top: 15px;
    font-size: 16px;
    text-align: center;
    color: white;
    padding: 0px 10px;
}
/* hide this element without adding the hidden tag to avoid errors */
.file-input {
    opacity: 0; 
    display: none;
}

section .row
{
    margin-bottom: 10px;
    background: #E9F0FF;
    list-style: none;
    padding: 15px 20px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

section .row i
{
    color: white;
    font-size: 30px;
}

section .details span
{
    font-size: 14px;
}

.add-buttons-container
{
    position: absolute;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
    margin-left : 20px;
    padding : 10px 10px;
    border-radius: 20px;
    bottom: -160%;
    left : 80%;
}

.add-page-button
{
    font-size: 18px;
    font-weight: 400;
    text-decoration: none;
    color: white;
    cursor: pointer;
    border: none;
    background-color: transparent;
    transition: all 0.3s ease-in-out;
    padding : 15px 10px;
    border-radius: 20px;
    width: 60%;
}

.add-page-button:hover
{
    background-color: #00468D;
}

::placeholder
{
    color : #9c9c9c;
}

.text-button-container
{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
}

.add-button-container
{
    display: flex;
    justify-content: center;
    align-items: center; 
    margin-top : 30px;
    margin-bottom: 15px;
}

.add-button
{
    color: #001E60;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    background-color: #ecaa1e;
    border-radius: 10px;
    cursor: pointer;
    padding: 5px 8px;
    border: none;
    transition: all 0.3s ease-in-out;
    line-height: 30px;
}

.delete-button
{
    color: white;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    background-color: transparent;
    border-radius: 10px;
    cursor: pointer;
    padding: 5px 8px;
    border: none;
}


.pop-up-container 
{
    position: fixed;
    top: -50px;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fade-in 0.2s ease-in-out;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
@keyframes fade-in 
{
    from {
      opacity: 0;
      top : -70px;
    }
    to {
      opacity: 1;
      top : -50px;
    }
  }

  @keyframes fades-in 
{
    from {
      opacity: 0;
      margin-bottom : 80px;
    }
    to {
      opacity: 1;
      margin-bottom : 50px;
    }
  }
  
.pop-up-overlay 
{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}
  
.pop-up-content 
{
    background-color:#0096C9;
    padding: 30px;
    border-radius: 10px;
    z-index: 1;
    width: 50%;
    padding-bottom: 35px;
}
  
.pop-up-content-title 
{
    margin-top : 10px;
    margin-bottom: 30px;
    color : white;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    padding : 10px 5px;
    background-color: #001E60;
    border-radius: 10px;
}

.pop-up-all-pages
{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.pop-up-page
{
    display: flex;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    width: 100%;
}
  
.pop-up-content-description
{
    text-align: center;
    margin-top: 30px;
    font-weight: 400;
    line-height: 35px;
}

.pop-up-content-description a
{
    margin-top : 20px;
    text-decoration: underline;
    text-underline-offset: 5px;
}

.service-create-account
{
    font-size: 18px;
    font-weight: 600;
    color: var(--dark-secondary-color);
    margin-top: 30px;
    padding: 10px 20px;
    background-color: var(--accent-color);
    border-radius: 20px;
    transition: 300ms ease;
}

.service-create-account:hover
{
    color: white;
    background-color: var(--secondary-color);
}

#container-photo-uploader
{
    width: 800px;
}

#contact-page-container
{
    display: flex;
    flex-wrap: wrap;
}


@media all and (max-width : 1300px)
{
    .meeting-details-text-box
    {
        width : 70%
    }
}

@media all and (max-width : 1200px)
{
    .service-info-container
    {
        padding-right : 1%;
        padding-left : 1%;
    }

    .service-description
    {
        margin : 50px 5%;
    }

    #container-photo-uploader
    {
        width: 650px;
    }

    #profile-icon-thumbnail
    {
        scale: 0.9;
    }

    #service-uploader
    {
        display: none;
    }
}

@media all and (max-width : 1050px)
{
    .pop-up-content
    {
        width : 75%;
    }

    .service-category
    {
        width : 100%;
        padding-left : 20px;
    }

    .meeting-details-text-box
    {
        font-size: 17px;
    }

    .meeting-description-text-box
    {
        font-size: 17px;
    }

    .service-info-container
    {
        padding-right: 2%;
        padding-left: 2%;
    }

    .service-header
    {
        font-size: 19px;
    }

    .service-description
    {
        font-size : 17px;
    }

    .service-details
    {
        font-size: 17px;
        padding: 14px 20px;
    }

    #overview-meeting-details
    {
        font-size: 17px;
        padding: 14px 20px;
    }

    .contacts-text-box
    {
        width : 90%;
    }
    
    .contacts-container input
    {
        font-size: 17px;
    }

    .club-contacts-selection
    {
        font-size: 17px;
    }

    .application-buttons
    {
        margin-top : 20px;
    }

    .sign-up-form-boxes
    {
        width : 80%;
    }
}

@media all and (max-width : 850px)
{
    #contact-container
    {
        width: 90%;
    }

    #requirements-container
    {
        margin-bottom: 0px;
    }

    #question-text-box
    {
        padding-top: 0px;
        padding-bottom: 0px;
        font-size: 18px;
    }

    #container-photo-uploader
    {
        width: 520px;
    }

    ::-webkit-scrollbar
    {
        height: 8px;
    }

    .service-navbar
    {
        justify-content: space-between;
        overflow: visible;
        flex-wrap: nowrap;
        overflow-y: hidden;
        margin-right: 8%;
        margin-left: 8%;
    }

    .service-navbar-text
    {
        margin-left: 0px;
        margin-right: 60px;
    }

    .service-navbar-link
    {
        white-space: nowrap;
    }

    .service-title
    {
        margin-top: 80px;
    }

    .authorization-container-title
    {
        font-size: 24px;
    }

    .authorization-container
    {
        margin: 0px 5%;
        margin-bottom: 50px;
    }

    .authorization-text
    {
        margin-top: 30px
    }

    .sign-up-return-button
    {
        width : 95%;
        font-size : 18px;
        margin-top: 60px;
    }

    .add-buttons-container
    {
        left: -150%;
        margin-left: 0px;
        flex-direction: row;
        background-color: #001E60;
    }

    .add-page-button
    {
        width: 70%;
    }

    .file-container
    {
        width : 80%;
        margin-bottom : 30px;
    }

    .service-info-container
    {
        padding-right : 0%;
        padding-left : 0%;
    }

    .service-image-container
    {
        width : 70%;
        max-height: 350px;
        margin-bottom: 40px;
    }


    .meeting-details-text-box
    {
        width : 75%;
    }

    .service-details
    {
        width : 80%;
        line-height: 40px;
    }

    #overview-meeting-details
    {
        width: 80%;
        line-height: 40px;
    }


    .service-description
    {
        font-size : 16px;
        line-height: 40px;
        margin: 50px 9%;
        padding : 10px 20px;
    }

    .application-buttons
    {
        font-size : 18px;
        width : 95%;
    }

    #name-container
    {
        width : 100%;
    }

    #email-container
    {
        width : 100%;
    }

    .sign-up-form-container
    {
        justify-content: center;
    }

    .service-category-container
    {
        font-size : 16px;
    }

    .service-category-title
    {
        font-size : 24px;
        line-height: 35px;
    }

    .service-category
    {
        padding-left : 0px;
    }

}

@media all and (max-width : 600px)
{
    .authorization-text
    {
        font-size: 14px;
    }

    .sign-up-submit-button 
    {
        width: 80%;
    }

    .service-navbar-text a
    {
        font-size: 16px;
    }

    #container-photo-uploader
    {
        width: 420px;
    }
}

@media all and (max-width : 480px)
{

    .service-author
    {
        line-height: 30px;
    }

    #question-text-box
    {
        font-size: 16px;
    }

    .file-container
    {
        height: 280px;
        padding: 15px;
    }

    .service-categories
    {
        padding-bottom: 10px;
    }

    .service-navbar-text 
    {
        margin-right: 40px;
    }

    .service-navbar-text a
    {
        font-size: 15px;
    }

    .pop-up-content
    {
        width : 90%;
        padding : 20px;
        padding-bottom : 40px;
        margin-top: 40px;
    }

    .pop-up-content-description
    {
        line-height: 25px;
    }

    .pop-up-content-title
    {
        font-size : 20px;
        margin-bottom : 30px;
    }

    .add-page-button
    {
        font-size : 16px;
        background-color: #00468D;
        width: 90%;
        margin-bottom : 20px;
    }

    .service-category-container
    {
        margin: 0px 3%;
        padding: 25px 25px;
    }

    .service-category-title
    {
        font-size : 20px;
    }

    .service-category
    {
        font-size : 14px;
        line-height: 25px;
        margin-right : 0px
    }

    .club-title-text-box
    {
        width: 95%;
    }

    .file-container
    {
        width : 95%;
    }

    .service-image-container
    {
        width : 90%;
        max-height: 350px;
    }


    .file-form
    {
        height: 130px;
    }

    .meeting-details-text-box
    {
        font-size : 15px;
    }

    .meeting-description-text-box
    {
        margin-top : 0px;
        margin-bottom : 0px;
        font-size: 15px;
    }

    .service-info2-container
    {
        padding-right: 2%;
        padding-left: 2%; 
    }

    .service-details
    {
        width : 95%;
        font-size: 15px;
    }

    #overview-meeting-details
    {
        width: 95%;
        font-size: 15px;
    }

    .service-description
    {
        font-size : 15px;
        line-height: 30px;
        padding : 10px 15px;
        margin: 30px 3%;
    }

    .authorization-container-title 
    {
        font-size: 20px;
    }

    .authorization-container
    {
        padding: 10px;
    }

    .authorization-text
    {
        font-size : 11px;
    }
    
    .contacts-container input
    {
        font-size: 15px;
        width: 100%;
    }

    .club-contacts-selection
    {
        font-size: 15px;
    }

    .sign-up-return-button
    {
        margin-top: 40px;
        font-size : 14px;
        letter-spacing: 1px;
        width: 100%;
    }

    .application-buttons
    {
        font-size: 14px;
        letter-spacing: 1px;
        width: 100%;
        margin-bottom: 30px;
    }

    .delete-button
    {
        font-size : 13px;
    }

    .add-button
    {
        font-size : 13px;
    }

    #faq-container
    {
        width : 90%;
    }

    #faq-title
    {
        margin-bottom : 0px;
        text-align: center;
    }

    #container-photo-uploader
    {
        width: 320px;
    }


}

@media all and (max-width : 360px)
{
    .file-form p
    {
        font-size: 12px;
    }

    .file-form
    {
        margin: 20px 0px 10px 0px;
    }

    .service-details
    {
        width : 95%;
        font-size: 13px;
    }

    #overview-meeting-details
    {
        width: 95%;
        font-size: 13px;
    }

    .service-description
    {
        font-size : 13px;
    }

    .meeting-details-text-box
    {
        font-size : 13px;
    }

    .meeting-description-text-box
    {
        font-size: 13px;
    }

    .service-details
    {
        font-size: 13px;
    }

    .service-description
    {
        font-size : 13px;
    }

    .authorization-container
    {
        font-size: 12px;
    }
    
    .contacts-container input
    {
        font-size: 13px;
    }

    .club-contacts-selection
    {
        font-size: 13px;
    }

    #container-photo-uploader
    {
        width: 300px;
    }


}
`, "",{"version":3,"sources":["webpack://./src/pages/my-services/add-service.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kCAAkC;IAClC,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,mCAAmC;IACnC,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;;AAGA;;IAEI,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;EACX;;AAEF;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;IACX,qBAAqB;AACzB;;AAEA;;IAEI,UAAU;IACV,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;AAC7B;;;AAGA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;;IAEI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;;;AAIA;;IAEI,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,aAAa;IACb,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;;IAEI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA,oEAAoE;AACpE;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;;IAEI,eAAe;IACf,UAAU;IACV,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;AAEF;;IAEI;MACE,UAAU;MACV,WAAW;IACb;IACA;MACE,UAAU;MACV,WAAW;IACb;EACF;;EAEA;;IAEE;MACE,UAAU;MACV,oBAAoB;IACtB;IACA;MACE,UAAU;MACV,oBAAoB;IACtB;EACF;;AAEF;;IAEI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;;IAEI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,eAAe;AACnB;;;AAGA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;;QAEI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,8BAA8B;QAC9B,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,cAAc;QACd,mBAAmB;IACvB;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,WAAW;QACX,oBAAoB;IACxB;;IAEA;;QAEI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;;;IAGA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,iBAAiB;IACrB;;IAEA;;QAEI,UAAU;QACV,iBAAiB;IACrB;;;IAGA;;QAEI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;AAEJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;AAEA;;;IAGI;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,aAAa;QACb,aAAa;IACjB;;IAEA;;QAEI,oBAAoB;IACxB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;QAChB,yBAAyB;QACzB,UAAU;QACV,oBAAoB;IACxB;;IAEA;;QAEI,cAAc;QACd,kBAAkB;IACtB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,iBAAiB;IACrB;;;IAGA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;IACf;;IAEA;;QAEI,eAAe;QACf,mBAAmB;QACnB,WAAW;QACX,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;;QAEI,YAAY;IAChB;;;AAGJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;;;AAGJ","sourcesContent":["*:focus \n{\n    outline: none;\n}\n\n:root\n{\n    --navbar-color : white;\n    --navbar-change-color : #001E60;\n}\n\ninput:-webkit-autofill, input:-webkit-autofill:focus \n{\n    transition: background-color 600000s 0s, color 600000s 0s;\n}\n\ninput[data-autocompleted] \n{\n    background-color: transparent !important;\n}\n\n.service-container\n{\n    color: white;\n    font-weight: 300;\n    transition: 300ms ease;\n    position: relative;\n    padding-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1600px;\n    overflow-x: hidden;\n}\n\n.service-title\n{\n    color: white;\n    font-size: clamp(18px, 5vw, 32px);\n    font-weight: 300;\n    text-decoration: none;\n    text-align: center;\n    background-color: #001E60;\n    margin-left: 5%;\n    margin-right: 5%;\n    margin-top : 1%;\n    border-radius: 10px;\n    padding: 10px 10px;\n    margin-bottom: 40px;\n}\n\n.service-navbar\n{\n    display: flex;\n    justify-content: space-evenly;\n    flex-flow: wrap;\n    margin-bottom : 40px;\n    margin-right: 5%;\n    margin-left: 5%;\n    padding-top: 10px;\n}\n\n.service-navbar-text\n{\n    padding-bottom : 4px;\n    transition: 300ms ease;\n    position: relative;\n    margin-right: 20px;\n    margin-left: 20px;\n    margin-bottom: 30px;\n}\n\n.service-navbar-link\n{\n    padding-bottom : 4px;\n    transition: 300ms ease;\n    position: relative;\n    border-bottom: 3px solid var(--navbar-color);\n}\n\n.service-navbar-text a\n{\n    text-decoration: none;\n    color: white;\n    font-size: 20px;\n    cursor: pointer;\n    font-weight: 400;\n    transition: 300ms ease;\n}\n\n.service-navbar-text a:hover\n{\n    color:#001E60;\n}\n\n.service-navbar-plus-container\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 25px;\n}\n\n#overview-meeting-details\n{\n    width: 45%;\n}\n\n.service-image-container\n{\n    width : 40%;\n    max-height: 350px;\n    border-radius : 20px;\n}\n\n#service-navbar-plus\n{\n    background-color:#001E60;\n    color: #ecaa1e;\n    cursor: pointer;\n    transition: 300ms ease;\n    border-radius: 10000px;\n    position: relative;\n}\n\n#remove-service-navbar-text\n{\n    position: absolute;\n    margin-left : 8px;\n    text-decoration: none;\n    color:#001E60;\n    background-color: #ecaa1e;\n    border-radius: 10000px;\n    cursor: pointer;\n    transition: 300ms ease;\n    scale: 1.3;\n    top: -5px;\n}\n\n#remove-service-navbar-text:hover\n{\n    background-color:#001E60;\n    color: #ecaa1e;\n}\n\n#select-navbar-section\n{\n    appearance: none;\n}\n.sign-up-form-box-input\n{\n    width: 100%;\n    background-color: #001E60;\n    color: white;\n    padding: 14px 20px;\n    margin: 8px 0;\n    margin-top: 10px;\n    border: none;\n    border-radius: 4px;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n}\n.sign-up-form\n{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 50px;\n}\n\n.hidden\n{\n    display: none;\n}\n\n.file-container p\n{\n    text-align: center;\n}\n\n.sign-up-form-container\n{\n    display: flex;\n    justify-content: space-between;\n    flex-flow: wrap;\n    align-items: center;\n}\n\n#sign-up-header\n{\n    font-size : 25px;\n    font-weight : 400;\n    margin-bottom : 40px;\n    text-align: center;\n}\n\n.sign-up-form-text\n{\n    display: block;\n    margin-bottom: 10px;\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.sign-up-form-input\n{\n    padding: 8px 10px;\n    margin-bottom: 60px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    font-size: 15px;\n    width: 100%;\n    color: #001E60;\n    font-weight: 400;\n}\n\n.sign-up-submit-container\n{\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    margin: 50px 0%;\n}\n\n.sign-up-submit-button \n{\n    width: 70%;\n    background-color: #001E60;\n    color: white;\n    padding: 14px 20px;\n    margin-top: 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n}\n\n.sign-up-submit-button:hover \n{\n    background-color: #ecaa1e;\n    color: #001E60;\n}\n\n.service-submit-button\n{\n    width: 100%;\n    background-color: #001E60;\n    color: white;\n    padding: 14px 20px;\n    margin: 8px 0;\n    margin-top: 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n}\n\n.service-submit-button:hover\n{\n    background-color: #ecaa1e;\n    color: #001E60;\n}\n\n#name-container\n{\n    width : 45%;\n}\n\n#email-container\n{\n    width : 45%;\n}\n\n.faq\n{\n    display: flex;\n    justify-content: center;\n}\n\n.service-info-container\n{\n    display: flex;\n    justify-content: space-evenly;\n    flex-flow: wrap;\n    align-items: flex-start;\n    padding-right: 4%;\n    padding-left: 4%;\n}\n\n.service-info2-container\n{\n    display: flex;\n    justify-content: space-around;\n    flex-flow: wrap;\n    align-items: flex-start;\n    padding-right: 5%;\n    padding-left: 5%;\n    margin-bottom : 8%;\n    padding-bottom: 5%;\n}\n\n#contact-container\n{\n    margin-bottom : 8%;\n}\n\n.service-author\n{\n    font-size : clamp(15px, 4vw, 25px);\n    display: flex;\n    justify-content: center;\n    padding-bottom : 15px;\n    text-align: center;\n}\n\n.service-header\n{\n    font-size : 22px;\n    display: flex;\n    justify-content: center;\n    padding-bottom: 5px;\n}\n\n.service-details\n{\n    color: white;\n    background-color: #00468D;\n    font-size: clamp(8px, 3vh, 20px);\n    font-weight: 400;\n    line-height: 50px;\n    position: relative;\n    width: 75%;\n    padding: 25px 25px;\n    border-radius: 20px;\n    background-size: cover;\n    transition: 300ms ease;\n}\n\n.service-details u\n{\n    text-decoration: none;\n    color: #ecaa1e;\n}\n\n.service-category-title\n{\n    text-align: center;\n    margin-bottom : 20px;\n    padding : 10px;\n    font-size: 26px;\n}\n\n.service-category-container\n{\n    color: white;\n    background-color: #00468D;\n    font-size: clamp(10px, 4vh, 20px);\n    font-weight: 400;\n    line-height: 50px;\n    padding: 25px 45px;\n    border-radius: 20px;\n    margin : 0px 8%;\n    margin-bottom: 200px;\n}\n\n.service-categories\n{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: center;\n    cursor: pointer;\n    padding-bottom : 50px;\n}\n\n.service-category\n{\n    width : 45%;\n    border-radius: 15px;\n    margin-right: 20px;\n    transition: 300ms ease;\n    padding-left: 15px;\n}\n\n.service-category:hover\n{\n    background-color: #001E60;\n}\n\n.service-description\n{\n    color: white;\n    background-color: #00468D;\n    font-size: clamp(10px, 4vh, 20px);\n    font-weight: 400;\n    line-height: 50px;\n    padding: 25px 45px;\n    border-radius: 20px;\n    margin : 50px 8%;\n    margin-bottom: 60px;\n}\n\n.meeting-description-text-box\n{\n    width : 100%;\n    padding: 8px 10px;\n    font-size: clamp(10px, 4vh, 20px);\n    margin-bottom: 20px;\n    margin-top : 10px;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n.authorization-container\n{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 0px 10%;\n    margin-bottom: 50px;\n    background-color:#0096C9;\n    padding: 20px;\n    border-radius: 10px;\n    animation: fades-in 0.2s ease-in-out;\n}\n\n.authorization-container-title\n{\n    font-size: 26px;\n    font-weight: 500;\n    margin-top : 20px;\n}\n\n.sign-up-title\n{\n    color: white;\n    font-size: clamp(20px, 2.3vw, 32px);\n    font-weight: 300;\n    text-decoration: none;\n    text-align: center;\n    background-color: #001E60;\n    margin-top : 2%;\n    border-radius: 10px;\n    padding: 10px 10px;\n    margin-bottom: 40px;\n}\n\n.sign-up-form-boxes\n{\n    width : 50%;\n}\n\n.club-title-text-box\n{\n    padding: 4px 10px;\n    font-size: clamp(22px, 3vw, 32px);\n    text-align: center;\n    width : 80%;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n.meeting-details-title-box\n{\n    font-size: clamp(15px, 2.3vw, 25px);\n    width : 80%;\n    text-align: center;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n.meeting-details-text-box\n{\n    padding: 4px 5px;\n    font-size: clamp(8px, 3vh, 20px);\n    width : 80%;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n.contacts-container\n{\n    margin-bottom: 10px;\n}\n\n#requirements-container\n{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.contacts-text-box\n{\n    padding: 4px 10px;\n    font-size: clamp(8px, 3vh, 20px);\n    width : 60%;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n\n.contacts-email-box\n{\n    padding: 4px 10px;\n    font-size: clamp(8px, 3vh, 20px);\n    width : 82%;\n    background : none;\n    border : none;\n    outline : none;\n    color : white;\n}\n\n.club-contacts-selection\n{\n    margin-top : 20px;\n    background : none;\n    border : none;\n    outline : none;\n    color : #ecaa1e;\n    font-size: clamp(8px, 3vh, 20px);\n}\n\n.category-selection\n{\n    margin-top : 20px;\n    background : none;\n    border : none;\n    outline : none;\n    color : #ecaa1e;\n    font-size: clamp(8px, 3vh, 20px);\n    margin-right: 5px;\n    \n}\n\n.category-select-button {\n    background-color: #001E60;\n    border-radius: 10px;\n    padding: none;\n    width: 25%;\n    position: relative;\n    top: 10px;\n  }\n\n.service-contact-name\n{\n    margin-right: 10px;\n}\n\n.service-contact-link\n{\n    text-decoration: underline;\n    text-underline-offset: 5px;\n}\n\n#question-text-box\n{\n    width : 98%;\n    word-wrap: break-word;\n}\n\n#answer-text-box\n{\n    width: 92%;\n    font-size: clamp(8px, 3vh, 18px);\n    margin-bottom : 20px;\n}\n\n#faq-container\n{\n    color: white;\n    background-color: #00468D;\n    font-size: clamp(8px, 3vh, 20px);\n    font-weight: 400;\n    line-height: 50px;\n    position: relative;\n    padding: 25px 25px;\n    border-radius: 20px;\n    background-size: cover;\n    transition: 300ms ease;\n    width: 80%;\n    margin-bottom: 100px;\n}\n\n#faq-title \n{\n    margin-bottom : 10px;\n}\n\n.application-buttons\n{\n    width: 90%;\n    background-color: #001E60;\n    color: white;\n    padding: 14px 20px;\n    margin-top: 40px;\n    margin-bottom: 40px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n    text-align: center;\n}\n\n.sign-up-return-button\n{\n    width: 90%;\n    background-color:#00468D;\n    color: white;\n    padding: 14px 20px;\n    margin-top: 80px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 2px;\n    transition: 300ms ease;\n    text-align: center;\n}\n\n.sign-up-return-button:hover\n{\n    background-color: #001E60;\n}\n\n.authorization-text\n{\n    width : 90%;\n    margin-top : 40px;\n}\n\n#draft-button\n{\n    margin-bottom : 0px;\n}\n\n#draft-button:hover\n{\n    background-color: #00468D;\n}\n\n\n#submit-button:hover \n{\n    background-color: #ecaa1e;\n    color : #00468D;\n}\n\n#save-button:hover \n{\n    background-color: #00468D;\n    color : #ecaa1e;\n}\n\n#file-container-with-file\n{\n    width: 40%;\n    background-color: #001E60;\n    border-radius: 20px;\n    padding: 30px;\n    box-shadow: 7px 7px 12px rgba(0,0,0,0.05);\n}\n\n.file-container\n{\n    width: 40%;\n    background: #00468D;\n    border-radius: 20px;\n    padding: 30px;\n    box-shadow: 7px 7px 12px rgba(0,0,0,0.05);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-evenly;\n    cursor: pointer;\n    height: 322px;\n    transition: 300ms ease;\n}\n\n\n\n.file-container header\n{\n    color: white;\n    font-size: clamp(20px, 2.3vw, 25px);\n    font-weight: 500;\n    text-align: center;\n}\n\n.file-container:hover {\n    background-color: var(--dark-secondary-color);\n}\n\n.file-form\n{\n    height: 150px;\n    display: flex;\n    cursor: pointer;\n    margin: 30px 0px 20px 0px;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border-radius: 5px;\n    border: 2px dashed white;\n    width: 80%;\n}\n\n#file-icon\n{\n    font-size: 50px;\n    color: white;\n    width : 100%;\n    display: flex;\n    justify-content: center;\n}\n\n\n.file-form p\n{\n    margin-top: 15px;\n    font-size: 16px;\n    text-align: center;\n    color: white;\n    padding: 0px 10px;\n}\n/* hide this element without adding the hidden tag to avoid errors */\n.file-input {\n    opacity: 0; \n    display: none;\n}\n\nsection .row\n{\n    margin-bottom: 10px;\n    background: #E9F0FF;\n    list-style: none;\n    padding: 15px 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\nsection .row i\n{\n    color: white;\n    font-size: 30px;\n}\n\nsection .details span\n{\n    font-size: 14px;\n}\n\n.add-buttons-container\n{\n    position: absolute;\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    flex-direction: column;\n    margin-left : 20px;\n    padding : 10px 10px;\n    border-radius: 20px;\n    bottom: -160%;\n    left : 80%;\n}\n\n.add-page-button\n{\n    font-size: 18px;\n    font-weight: 400;\n    text-decoration: none;\n    color: white;\n    cursor: pointer;\n    border: none;\n    background-color: transparent;\n    transition: all 0.3s ease-in-out;\n    padding : 15px 10px;\n    border-radius: 20px;\n    width: 60%;\n}\n\n.add-page-button:hover\n{\n    background-color: #00468D;\n}\n\n::placeholder\n{\n    color : #9c9c9c;\n}\n\n.text-button-container\n{\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.add-button-container\n{\n    display: flex;\n    justify-content: center;\n    align-items: center; \n    margin-top : 30px;\n    margin-bottom: 15px;\n}\n\n.add-button\n{\n    color: #001E60;\n    font-size: 15px;\n    font-weight: 600;\n    text-decoration: none;\n    background-color: #ecaa1e;\n    border-radius: 10px;\n    cursor: pointer;\n    padding: 5px 8px;\n    border: none;\n    transition: all 0.3s ease-in-out;\n    line-height: 30px;\n}\n\n.delete-button\n{\n    color: white;\n    font-size: 15px;\n    font-weight: 600;\n    text-decoration: none;\n    background-color: transparent;\n    border-radius: 10px;\n    cursor: pointer;\n    padding: 5px 8px;\n    border: none;\n}\n\n\n.pop-up-container \n{\n    position: fixed;\n    top: -50px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    animation: fade-in 0.2s ease-in-out;\n}\n\n.popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n  }\n  \n@keyframes fade-in \n{\n    from {\n      opacity: 0;\n      top : -70px;\n    }\n    to {\n      opacity: 1;\n      top : -50px;\n    }\n  }\n\n  @keyframes fades-in \n{\n    from {\n      opacity: 0;\n      margin-bottom : 80px;\n    }\n    to {\n      opacity: 1;\n      margin-bottom : 50px;\n    }\n  }\n  \n.pop-up-overlay \n{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n}\n  \n.pop-up-content \n{\n    background-color:#0096C9;\n    padding: 30px;\n    border-radius: 10px;\n    z-index: 1;\n    width: 50%;\n    padding-bottom: 35px;\n}\n  \n.pop-up-content-title \n{\n    margin-top : 10px;\n    margin-bottom: 30px;\n    color : white;\n    text-align: center;\n    font-size: 24px;\n    font-weight: 500;\n    padding : 10px 5px;\n    background-color: #001E60;\n    border-radius: 10px;\n}\n\n.pop-up-all-pages\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.pop-up-page\n{\n    display: flex;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n  \n.pop-up-content-description\n{\n    text-align: center;\n    margin-top: 30px;\n    font-weight: 400;\n    line-height: 35px;\n}\n\n.pop-up-content-description a\n{\n    margin-top : 20px;\n    text-decoration: underline;\n    text-underline-offset: 5px;\n}\n\n.service-create-account\n{\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--dark-secondary-color);\n    margin-top: 30px;\n    padding: 10px 20px;\n    background-color: var(--accent-color);\n    border-radius: 20px;\n    transition: 300ms ease;\n}\n\n.service-create-account:hover\n{\n    color: white;\n    background-color: var(--secondary-color);\n}\n\n#container-photo-uploader\n{\n    width: 800px;\n}\n\n#contact-page-container\n{\n    display: flex;\n    flex-wrap: wrap;\n}\n\n\n@media all and (max-width : 1300px)\n{\n    .meeting-details-text-box\n    {\n        width : 70%\n    }\n}\n\n@media all and (max-width : 1200px)\n{\n    .service-info-container\n    {\n        padding-right : 1%;\n        padding-left : 1%;\n    }\n\n    .service-description\n    {\n        margin : 50px 5%;\n    }\n\n    #container-photo-uploader\n    {\n        width: 650px;\n    }\n\n    #profile-icon-thumbnail\n    {\n        scale: 0.9;\n    }\n\n    #service-uploader\n    {\n        display: none;\n    }\n}\n\n@media all and (max-width : 1050px)\n{\n    .pop-up-content\n    {\n        width : 75%;\n    }\n\n    .service-category\n    {\n        width : 100%;\n        padding-left : 20px;\n    }\n\n    .meeting-details-text-box\n    {\n        font-size: 17px;\n    }\n\n    .meeting-description-text-box\n    {\n        font-size: 17px;\n    }\n\n    .service-info-container\n    {\n        padding-right: 2%;\n        padding-left: 2%;\n    }\n\n    .service-header\n    {\n        font-size: 19px;\n    }\n\n    .service-description\n    {\n        font-size : 17px;\n    }\n\n    .service-details\n    {\n        font-size: 17px;\n        padding: 14px 20px;\n    }\n\n    #overview-meeting-details\n    {\n        font-size: 17px;\n        padding: 14px 20px;\n    }\n\n    .contacts-text-box\n    {\n        width : 90%;\n    }\n    \n    .contacts-container input\n    {\n        font-size: 17px;\n    }\n\n    .club-contacts-selection\n    {\n        font-size: 17px;\n    }\n\n    .application-buttons\n    {\n        margin-top : 20px;\n    }\n\n    .sign-up-form-boxes\n    {\n        width : 80%;\n    }\n}\n\n@media all and (max-width : 850px)\n{\n    #contact-container\n    {\n        width: 90%;\n    }\n\n    #requirements-container\n    {\n        margin-bottom: 0px;\n    }\n\n    #question-text-box\n    {\n        padding-top: 0px;\n        padding-bottom: 0px;\n        font-size: 18px;\n    }\n\n    #container-photo-uploader\n    {\n        width: 520px;\n    }\n\n    ::-webkit-scrollbar\n    {\n        height: 8px;\n    }\n\n    .service-navbar\n    {\n        justify-content: space-between;\n        overflow: visible;\n        flex-wrap: nowrap;\n        overflow-y: hidden;\n        margin-right: 8%;\n        margin-left: 8%;\n    }\n\n    .service-navbar-text\n    {\n        margin-left: 0px;\n        margin-right: 60px;\n    }\n\n    .service-navbar-link\n    {\n        white-space: nowrap;\n    }\n\n    .service-title\n    {\n        margin-top: 80px;\n    }\n\n    .authorization-container-title\n    {\n        font-size: 24px;\n    }\n\n    .authorization-container\n    {\n        margin: 0px 5%;\n        margin-bottom: 50px;\n    }\n\n    .authorization-text\n    {\n        margin-top: 30px\n    }\n\n    .sign-up-return-button\n    {\n        width : 95%;\n        font-size : 18px;\n        margin-top: 60px;\n    }\n\n    .add-buttons-container\n    {\n        left: -150%;\n        margin-left: 0px;\n        flex-direction: row;\n        background-color: #001E60;\n    }\n\n    .add-page-button\n    {\n        width: 70%;\n    }\n\n    .file-container\n    {\n        width : 80%;\n        margin-bottom : 30px;\n    }\n\n    .service-info-container\n    {\n        padding-right : 0%;\n        padding-left : 0%;\n    }\n\n    .service-image-container\n    {\n        width : 70%;\n        max-height: 350px;\n        margin-bottom: 40px;\n    }\n\n\n    .meeting-details-text-box\n    {\n        width : 75%;\n    }\n\n    .service-details\n    {\n        width : 80%;\n        line-height: 40px;\n    }\n\n    #overview-meeting-details\n    {\n        width: 80%;\n        line-height: 40px;\n    }\n\n\n    .service-description\n    {\n        font-size : 16px;\n        line-height: 40px;\n        margin: 50px 9%;\n        padding : 10px 20px;\n    }\n\n    .application-buttons\n    {\n        font-size : 18px;\n        width : 95%;\n    }\n\n    #name-container\n    {\n        width : 100%;\n    }\n\n    #email-container\n    {\n        width : 100%;\n    }\n\n    .sign-up-form-container\n    {\n        justify-content: center;\n    }\n\n    .service-category-container\n    {\n        font-size : 16px;\n    }\n\n    .service-category-title\n    {\n        font-size : 24px;\n        line-height: 35px;\n    }\n\n    .service-category\n    {\n        padding-left : 0px;\n    }\n\n}\n\n@media all and (max-width : 600px)\n{\n    .authorization-text\n    {\n        font-size: 14px;\n    }\n\n    .sign-up-submit-button \n    {\n        width: 80%;\n    }\n\n    .service-navbar-text a\n    {\n        font-size: 16px;\n    }\n\n    #container-photo-uploader\n    {\n        width: 420px;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n\n    .service-author\n    {\n        line-height: 30px;\n    }\n\n    #question-text-box\n    {\n        font-size: 16px;\n    }\n\n    .file-container\n    {\n        height: 280px;\n        padding: 15px;\n    }\n\n    .service-categories\n    {\n        padding-bottom: 10px;\n    }\n\n    .service-navbar-text \n    {\n        margin-right: 40px;\n    }\n\n    .service-navbar-text a\n    {\n        font-size: 15px;\n    }\n\n    .pop-up-content\n    {\n        width : 90%;\n        padding : 20px;\n        padding-bottom : 40px;\n        margin-top: 40px;\n    }\n\n    .pop-up-content-description\n    {\n        line-height: 25px;\n    }\n\n    .pop-up-content-title\n    {\n        font-size : 20px;\n        margin-bottom : 30px;\n    }\n\n    .add-page-button\n    {\n        font-size : 16px;\n        background-color: #00468D;\n        width: 90%;\n        margin-bottom : 20px;\n    }\n\n    .service-category-container\n    {\n        margin: 0px 3%;\n        padding: 25px 25px;\n    }\n\n    .service-category-title\n    {\n        font-size : 20px;\n    }\n\n    .service-category\n    {\n        font-size : 14px;\n        line-height: 25px;\n        margin-right : 0px\n    }\n\n    .club-title-text-box\n    {\n        width: 95%;\n    }\n\n    .file-container\n    {\n        width : 95%;\n    }\n\n    .service-image-container\n    {\n        width : 90%;\n        max-height: 350px;\n    }\n\n\n    .file-form\n    {\n        height: 130px;\n    }\n\n    .meeting-details-text-box\n    {\n        font-size : 15px;\n    }\n\n    .meeting-description-text-box\n    {\n        margin-top : 0px;\n        margin-bottom : 0px;\n        font-size: 15px;\n    }\n\n    .service-info2-container\n    {\n        padding-right: 2%;\n        padding-left: 2%; \n    }\n\n    .service-details\n    {\n        width : 95%;\n        font-size: 15px;\n    }\n\n    #overview-meeting-details\n    {\n        width: 95%;\n        font-size: 15px;\n    }\n\n    .service-description\n    {\n        font-size : 15px;\n        line-height: 30px;\n        padding : 10px 15px;\n        margin: 30px 3%;\n    }\n\n    .authorization-container-title \n    {\n        font-size: 20px;\n    }\n\n    .authorization-container\n    {\n        padding: 10px;\n    }\n\n    .authorization-text\n    {\n        font-size : 11px;\n    }\n    \n    .contacts-container input\n    {\n        font-size: 15px;\n        width: 100%;\n    }\n\n    .club-contacts-selection\n    {\n        font-size: 15px;\n    }\n\n    .sign-up-return-button\n    {\n        margin-top: 40px;\n        font-size : 14px;\n        letter-spacing: 1px;\n        width: 100%;\n    }\n\n    .application-buttons\n    {\n        font-size: 14px;\n        letter-spacing: 1px;\n        width: 100%;\n        margin-bottom: 30px;\n    }\n\n    .delete-button\n    {\n        font-size : 13px;\n    }\n\n    .add-button\n    {\n        font-size : 13px;\n    }\n\n    #faq-container\n    {\n        width : 90%;\n    }\n\n    #faq-title\n    {\n        margin-bottom : 0px;\n        text-align: center;\n    }\n\n    #container-photo-uploader\n    {\n        width: 320px;\n    }\n\n\n}\n\n@media all and (max-width : 360px)\n{\n    .file-form p\n    {\n        font-size: 12px;\n    }\n\n    .file-form\n    {\n        margin: 20px 0px 10px 0px;\n    }\n\n    .service-details\n    {\n        width : 95%;\n        font-size: 13px;\n    }\n\n    #overview-meeting-details\n    {\n        width: 95%;\n        font-size: 13px;\n    }\n\n    .service-description\n    {\n        font-size : 13px;\n    }\n\n    .meeting-details-text-box\n    {\n        font-size : 13px;\n    }\n\n    .meeting-description-text-box\n    {\n        font-size: 13px;\n    }\n\n    .service-details\n    {\n        font-size: 13px;\n    }\n\n    .service-description\n    {\n        font-size : 13px;\n    }\n\n    .authorization-container\n    {\n        font-size: 12px;\n    }\n    \n    .contacts-container input\n    {\n        font-size: 13px;\n    }\n\n    .club-contacts-selection\n    {\n        font-size: 13px;\n    }\n\n    #container-photo-uploader\n    {\n        width: 300px;\n    }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
